<template>
  <router-view />
</template>

<script setup lang="ts">
import { useColorMode, useEventListener } from '@vueuse/core';

import { useTitle } from '@libs/use';
import { dataLayer } from '@libs/gtm';
import { featureFlag } from '@libs/feature-flag';

import { useGetOmsStatusQuery } from '@core/order';
import { useUser } from '@core/user';

import useSentry from '@/composables/useSentry';
import useWebEngage from '@/composables/useWebEngage';

import { useUserLiveMessages } from '@/modules/user';

const sentry = useSentry();
const { onUserReady } = useUser();

useGetOmsStatusQuery();

const { webEngage, onWebEngageReady } = useWebEngage();

onUserReady((user) => {
  featureFlag.initiate();

  dataLayer.push({
    event: 'userReceived',
    user_id: user.personageId,
  });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error

  sentry.setUser({
    id: user.userTitle,
    username: user.userName,
    email: user.nationalCode,
  });

  useEventListener(window, 'load', () => {
    (window as any)?.clarity?.('identify', String(user.personageId));
  });

  onWebEngageReady(() => {
    webEngage.triggerLogin(user.trackerId);
  });
});

useColorMode({
  selector: 'body',
  attribute: 'data-theme',
  initialValue: 'light',
});

useTitle();
useUserLiveMessages();
</script>
